<template lang="pug">
  FullView(
    v-if='playlist'
    type='playlist'
    :id='playlist.id'
    :cover='playlist.cover'
    :editable='$accessControl.owner("playlists", playlist.id)'
    :removable='$accessControl.owner("playlists", playlist.id)'
    :running='running'
    :label='$l10n("PLAYLIST").toLowerCase()'
    :title='playlist.title || $l10n("NO_NAME")'
    :created='playlist.created_at'
    :controls='["play", "shuffle", "repeat"]'
    @play='$emit("play")'
    @pause='$emit("pause")'
    @delete='$emit("delete")'
  )
</template>

<script>
import FullView from "@/components/FullView/FullView";

export default {
  name: "PlaylistFullView",
  props: ["playlist", "running"],
  components: {
    FullView
  }
};
</script>
